/**
 * FibreBeams — the LIGHT travelling down a member's connector while that
 * member has runs in flight.
 *
 * Rendered by ReadonlyLabeledEdge next to its BaseEdge, on the SAME path
 * string, so the light rides exactly the line the eye already follows. Two
 * overlay copies of the path: a wide, blurred, low-alpha GLOW (the halo) and a
 * short bright HEAD at its front. Both carry pathLength="100", so a dash of `n`
 * is n% of THIS connector whatever its length, and one dashoffset cycle
 * (100 → 0 — moving WITH the path's direction, parent → member) is one pulse
 * end to end. The head leads the glow by --fibre-lead, subtracted inside the
 * shared keyframe, so the two can never drift apart.
 *
 * SPEED is the group's --fibre-period, from `fibrePeriodCss(activeRuns)` — the
 * same count the satellite's paper stack is drawn from. Idle (0 runs) renders
 * NOTHING: the connector is byte-for-byte the plain dashed line it was.
 *
 * Reduced motion: no travel — the lit line breathes slowly instead (a fade,
 * never a removal of the running signal). See FibreBeams.css.
 */
import React from 'react';
import { fibrePeriodCss } from '../utils/fibre';
import './FibreBeams.css';

/** The stroke the STATIC connector takes while lit — a dimmer white; the fibre glows from inside. */
export const FIBRE_DIM_STROKE = 'rgba(255, 255, 255, 0.55)';

export const FibreBeams = ({ path, activeRuns }) => {
  const period = fibrePeriodCss(activeRuns);
  if (!period || !path) return null;
  return (
    <g className="gwe-fibre is-running" style={{ '--fibre-period': period }} aria-hidden>
      <path className="gwe-fibre__beam gwe-fibre__glow" d={path} pathLength={100} />
      <path className="gwe-fibre__beam gwe-fibre__head" d={path} pathLength={100} />
    </g>
  );
};

export default FibreBeams;
